import { createContext } from "react";

const ContabilidadFacturasContext = createContext();

export default ContabilidadFacturasContext;
